import React, { useState, useEffect } from 'react';
import { Dialog, Box, Typography, ListItem, IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Close } from '@material-ui/icons';
import { useTranslate, useDataProvider } from 'react-admin';
import IconButtonCustom from '../button/icon-button';
import SelectBox from '../../CustomizedUIs/CustomSelectBox';
import { generateRandomString } from '../../utils';
import { changeInfoPageDirtyStatus, changeTreeData } from '../../redux/actions/tree-action';
import { useDispatch, useSelector } from 'react-redux';
import { cloneDeep } from 'lodash';
import SelectBoxFilter from '../select-box-filter';

const useStyles = makeStyles(theme => ({
    dialogCloseBtn: {
        backgroundColor: theme.palette.common.white,
        marginLeft: 10
    },
    textLabel: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.85,
        letterSpacing: '0.13px',
        color: ' #88898c',
    },
    TexTSelect: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: '0.13px',
        color: '#4f5064',
    },
}));

function DialogChooseInfoPage({ open, data, clusterData, specialLocation, onClose }) {
    const classes = useStyles();
    const translate = useTranslate();
    const dataProvider = useDataProvider();
    const [infoPage, setInfoPage] = useState('');
    const [infoPages, setInfoPages] = useState([]);

    const onChange = (value) => {
        if (value.name === 'None')
            setInfoPage('')
        else
            setInfoPage(value)
    }

    const handleSave = () => {
        dataProvider('UPDATE', `change-room-location-infopage`, {
            id: clusterData.id,
            data: {
                cluster: clusterData.id,
                location: data.location,
                specialLocation: specialLocation,
                infoPage: infoPage
            }
        }).then(({ data }) => {
            handleClose(data || null);
        }).catch(error => {
        });

    }

    const onEnter = () => {
        let request = []
        let infoPages = []
        let infoPage = []
        request.push(
            dataProvider('GET_LIST', 'info-page-list', {
                sort: { field: 'name', order: 'ASC' },
                pagination: { page: 0, perPage: 1 },
                filter: {}
            }).then(({ data }) => {
                // let temp = []
                // temp.push({
                //     createdAt: 1603093930191,
                //     id: 0,
                //     name: "None",
                //     template: { createdAt: 1601363433534, updatedAt: 1601363433534, id: 2, name: "staff" },
                //     updatedAt: 1611650835649,
                //     version: 0,
                // })
                // data.map(item => {
                //     temp.push(item)
                // })
                // setInfoPages(temp)
                // infoPages = temp
                setInfoPages(data)
                infoPages = data
            }
            ).catch(error => {
                console.log('error', error)
            }),
            dataProvider('GET_LIST', 'room-location-infopage', {
                sort: { field: 'name', order: 'ASC' },
                pagination: { page: 0, perPage: 1 },
                filter: {
                    cluster: clusterData.id,
                    location: data.location,
                    specialLocation: specialLocation,
                    messages: true
                }
            }).then(({ data }) => {
                if (data)
                    infoPage = data
            }
            ).catch(error => {
                console.log('error', error.message)
            })
        )
        Promise.all(request)
            .then(() => {
                infoPages.forEach(item => {
                    if (item.id === infoPage.infoPage)
                        setInfoPage(item)
                });
            })
            .catch(error => {
                console.log('Error', error)
            })
    }

    const handleClose = (data) => {
        let clone = cloneDeep(infoPage)
        onClose(clone, data);
        setInfoPage('')
    }

    return (
        <Dialog onEnter={onEnter} open={open} onClose={handleClose} aria-labelledby="form-dialog-title" disableEnforceFocus disableBackdropClick >
            <Box width={400} textAlign='center'>
                <Box display='flex' justifyContent='flex-end' alignItems='center' mr={2} mt={1}>
                    <Typography variant='subtitle2'>{translate(`pos.user.close`)}</Typography>
                    <IconButton size='small' className={classes.dialogCloseBtn} onClick={handleClose}>
                        <Close color='primary' />
                    </IconButton>
                </Box>
                <Box display='flex' justifyContent='center' width='100%' mt={2}>
                    <Box style={{ width: 300 }}>
                        <SelectBoxFilter
                            data={infoPages}
                            label={translate('pos.settings.infoPage')}
                            value={infoPage ? infoPage.name : ''}
                            onChange={(value) => onChange(value)}
                            keyName='name'
                            placeholder={translate('pos.settings.searchInfoPage')}
                        />
                    </Box>
                </Box>
                <Box display='flex' justifyContent='center' width='100%' mt={2} mb={2}>
                    <IconButtonCustom
                        // disabled={!infoPage}
                        label={translate('pos.common.save')}
                        onClick={handleSave}
                        style={{ marginRight: 10 }}
                    />
                </Box>
            </Box>
        </Dialog>
    );
}

export default DialogChooseInfoPage;
